import { DESKTOP, MOBILE } from '@/src/constants/deviceTypes'
import { UAParser } from 'ua-parser-js'
import { logError } from '../logError'

export const getDeviceType = () => {
    try {
        const userAgent = window.navigator.userAgent.toLowerCase()
        const parser = new UAParser(userAgent)
        const device = parser.getDevice()
        const deviceType = device.type === 'mobile' || device.type === 'tablet' ? MOBILE : DESKTOP
        return deviceType || DESKTOP
    } catch (error) {
        logError('getDeviceType', error)
        return DESKTOP
    }
}
